import { Box, useMediaQuery, useTheme } from "@mui/material";

import { trackEvent } from "utils/tracking";

import styles from "./styles";

interface Props {
  hideMenu?: boolean;
  mergeTags?: string[];
  editor: any;
  isSubjectLine?: boolean;
}

const MergeTagMenuBar = ({
  hideMenu,
  mergeTags,
  editor,
  isSubjectLine = false,
}: Props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const displayMergeTagMenuBar = Boolean(
    !hideMenu && mergeTags && mergeTags.length > 0,
  );

  if (!displayMergeTagMenuBar) return null;

  return (
    <Box sx={styles.mergeTagContainer}>
      <Box component="span" sx={styles.label}>
        <Box component="i" className="fa-regular fa-at" sx={styles.labelIcon} />
        {isMobileScreen ? "Tags" : "Personalization tags"}
      </Box>
      {mergeTags?.map((tag) => (
        <Box
          key={tag}
          sx={styles.mergeTag}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => {
            trackEvent("Email Template Clicked Insert Merge Tag", {
              label: tag,
            });
            editor
              .chain()
              .focus()
              .insertContentAt(editor.state.selection.anchor, [
                {
                  type: "merge-tag",
                  attrs: { label: tag },
                },
              ])
              .run();
          }}
        >
          {`{${tag}}`}
        </Box>
      ))}
      {!isMobileScreen && (
        <Box component="span" sx={styles.hint}>
          <Box
            component="i"
            className="fa-regular fa-arrow-pointer"
            sx={styles.hintIcon}
          />
          Inserts into the {isSubjectLine ? "subject line" : "email body"}
        </Box>
      )}
    </Box>
  );
};

export default MergeTagMenuBar;
